'use client'
import { Prefooter as BasePreFooter } from 'components/blog-posts/prefooter/prefooter'
import Interpolate from 'components/Interpolate/Interpolate'
import { useLocale } from 'next-intl'

import { useTranslation } from '@/app/i18n/client'

export function Prefooter() {
    const locale = useLocale()
    const { t } = useTranslation(locale, 'productivity-methods')
    const { t: tCommon } = useTranslation(locale, 'common')
    return (
        <BasePreFooter
            backgroundColor="var(--sea-salt-100)"
            title={<Interpolate t={t} i18nKey="prefooter.title" />}
            subtitle={t('prefooter.desc')}
            illustration={{
                src: `${process.env.NEXT_PUBLIC_BASE_URL}/static/productivitymethods/illustration-ducks.png`,
                width: 520,
                height: 320,
            }}
            getStartedForFree={tCommon('getStartedForFree')}
        />
    )
}
